import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Select, Typography, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  getUpdateVehicleDisable,
  getVehicleDetailList,
  incrementActiveTab,
} from '@src/store/slice/vehicleManagementStore/vehicleManagementDetailSlice';
import { Text as CustomText, useText } from '@src/components';
const { Text } = Typography;
const { Option } = Select;

const VehicleManagementDetailCancelDeviceModal = ({
  isVisible,
  handleOk,
  handleCancel,
  vehicleId,
  vehicleDetailId,
  providerType,
  status,
  plate,
}) => {
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();
  const temporarilyStopFuelPurchase = useText('temporarilyStopFuelPurchase');
  const openFuelPurchase2 = useText('openFuelPurchase2');
  const transactionSuccessfullyCompleted2 = useText('transactionSuccessfullyCompleted2');
  const { loading: loadingVehicleCancelDevice } = useSelector(
    (state) => state.vehicleManagementDetail,
  );
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { isAdmin } = useSelector((state) => state.auth);
  const { selectedUserId } = useSelector((state) => state.user);
  const isStatusAktif = status === 'Aktif';

  const onOk = async () => {
    try {
      const request = {
        vehicleDetailIds: [vehicleDetailId],
        isDisabled: isStatusAktif,
        plate,
      };
      const response = await dispatch(getUpdateVehicleDisable({ request })).unwrap();
      if (response.isSuccess) {
        api.success({
          message: isStatusAktif ? temporarilyStopFuelPurchase : openFuelPurchase2,
          description: transactionSuccessfullyCompleted2,
          duration: 2,
        });
      }
      handleOk();
      setTimeout(async () => {
        await dispatch(
          getVehicleDetailList({
            customerId: isAdmin && selectedUserId ? selectedUserId : selectedCustomer.customerId,
            id: vehicleId,
            providerType: providerType,
          }),
        );
        await dispatch(incrementActiveTab('2'));
      }, 1500);
    } catch (error) {
      console.log('Validate Failed:', error);
    }
  };

  const onCancel = () => {
    handleCancel();
  };

  return (
    <>
      {contextHolder}
      {isVisible && (
        <div data-testid="vehicle-model-device-cancel-id">
          <Modal
            title={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ExclamationCircleOutlined
                  style={{ color: '#FAAD14', fontSize: '24px', marginRight: '8px' }}
                />
                <Text strong style={{ fontSize: '16px' }}>
                  <CustomText t="attention" />
                </Text>
              </div>
            }
            visible={isVisible}
            onOk={onOk}
            onCancel={onCancel}
            footer={[
              <Button key="back" onClick={handleCancel}>
                <CustomText t="giveUp" />
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={onOk}
                loading={loadingVehicleCancelDevice.vehicleCancelDeviceModal}
                disabled={loadingVehicleCancelDevice.vehicleCancelDeviceModal}
                data-testid="yes-button"
              >
                <CustomText t="yes" />
              </Button>,
            ]}
          >
            <Text strong style={{ fontSize: '18px' }}>
              Seçili cihazı{' '}
              {isStatusAktif ? 'geçici olarak yakıt alımına durdurmak' : 'yakıt alımına açmak'}{' '}
              istediğinize emin misiniz?
            </Text>
          </Modal>
        </div>
      )}
    </>
  );
};

VehicleManagementDetailCancelDeviceModal.propTypes = {
  isVisible: PropTypes.bool,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
  vehicleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vehicleDetailId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  providerType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  status: PropTypes.string,
  plate: PropTypes.string,
};

export default VehicleManagementDetailCancelDeviceModal;
